export const mapProductOrderStatus = (orderStatus?: string) => {
    switch (orderStatus) {
        case 'OPEN':
            return 'open';
        case 'PROCESSING':
            return 'processing';
        case 'SHIPPING':
            return 'shipping';
        case 'CANCELLED':
            return 'cancelled';
        case 'NO_LONGER_AVAILABLE_FOR_SALE':
            return 'noLongerAvailableForSale';
        case 'COMPLETE':
            return 'complete';
        case 'PRE_ORDERED_SHIPPING':
            return 'preOrderedShipping';
        case 'PRE_ORDERED_COMPLETE':
            return 'preOrderedComplete';
        case 'PRE_ORDERED_OPEN':
            return 'preOrderedOpen';
        case 'PRE_ORDERED_PROCESSING':
            return 'preOrderedProcessing';
        case 'PRE_ORDERED_PREPARING':
            return 'preOrderedPreparing';
        case 'PRE_ORDERED_CANCELLED':
            return 'preOrderedCancelled';
        case 'PRE_ORDERED_NO_LONGER_AVAILABLE_FOR_SALE':
            return 'preOrderedNoLongerAvailableForSale';
        case 'PRE_ORDERED_EXPECTED':
            return 'preOrderedExpected';
        case 'PRE_ORDERED_DELAYED':
            return 'preOrderedDelayed';
        case 'PRE_ORDERED_EMBARGO':
            return 'preOrderedEmbargo';
        default:
            return null;
    }
};
